import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import { Component } from 'react';
import { analytics } from 'app/utils/segment';
import { TopbarButton } from '../../topbar/components/topbarButton';
import '../styles/beamer-button.less';
class BeamerButton extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        const { id, is_admin, email, name } = this.props.profile;
        const { created_at } = this.props.organization;
        const nameArr = name ? name.split(/\s+/) : [];
        window.beamer_config.user_id = id;
        window.beamer_config.filter = is_admin ? 'admin' : 'agent';
        window.beamer_config.user_email = email;
        window.beamer_config.organization_created_at = created_at;
        window.beamer_config.user_firstname = nameArr.shift();
        window.beamer_config.user_lastname = nameArr.join(' ');
        if (window.Beamer) {
            window.Beamer.init();
        }
        else {
            window.beamer_config.callback = () => {
                window.Beamer.init();
            };
        }
    }
    render() {
        const { className } = this.props;
        const rootClass = classnames({}, className);
        return (_jsx(TopbarButton, { id: "topbar-beamer", tooltip: "What's new", className: rootClass + ' pull-right', onClick: () => {
                window.Beamer.show();
                analytics.topbarBeamerOpened();
            }, icon: "gift" }));
    }
}
export default BeamerButton;
